
import React, { useState } from 'react';

import { useToggle } from '@hooks/useToggle';

import { LOCAL_STORAGE_SETTINGS_KEY } from '@utils/tools/localStorageHyperDashboardTools';
import { cloneObject } from '@utils/miscellaneous/cloneObject';

const DropdownForSettings = props => {

    const {
        value,
        settingName,
        handleInputChange,
        options,
        modifier,
        settings
    } = props;

    const [ isToggled, toggle ] = useToggle(false);
    
    const defaultOption = {
        text: 'New User',
        value: {
            'X-UID': null,
            'X-EMAIL': null
        }
    };

    const [ dropdownOptions, setDropdownOptions ] = useState([
        ...options,
        ...(modifier ? [ defaultOption ] : [])
    ]);

    const checkValue = (prevValue, newValue) => (newValue === null || newValue === '') ? prevValue : newValue;

    const handleEditClick = e => {
        const {
            target: {
                dataset: {
                    user_index,
                    key_name
                }
            }
        } = e;

        setDropdownOptions(dropdownOptions => 
            dropdownOptions
                .map((option, idx) => {
                    return idx === Number(user_index) ?
                        {
                            ...option,
                            value: {
                                ...option.value,
                                [key_name]: (i => key_name === 'X-UID' ? Number(i) : String(i))(prompt('Enter new value', option.value[key_name]))
                            }
                        } :  option;
                })
        );

        setDropdownOptions(dropdownOptions =>
            dropdownOptions.length - 1 === Number(user_index) ?
                [
                    ...dropdownOptions,
                    defaultOption
                ] :
                dropdownOptions
        );
    };

    const handleDeletion = e => {
        const {
            target: {
                name: indexToSplice
            }
        } = e;

        setDropdownOptions(dropdownOptions => dropdownOptions.filter((o, idx) => idx !== Number(indexToSplice)));
    };

    const handleModClick = () => {

        if(isToggled) {

            const clonedDropdownOptions = cloneObject(dropdownOptions);

            const newSettings = {
                ...settings,
                [settingName]: {
                    ...settings[settingName],
                    options: clonedDropdownOptions.filter(o => Object.values(o.value).some(v => v))
                }
            };

            localStorage.setItem(LOCAL_STORAGE_SETTINGS_KEY, JSON.stringify(newSettings));
        }
        toggle();
    };

    const handleTextChange = e => {
        const {
            target: {
                dataset: {
                    user_index
                }
            }
        } = e;

        setDropdownOptions(dropdownOptions => dropdownOptions.map((option, idx) => {
            return idx === Number(user_index) ?
                {
                    ...option,
                    text: (i => checkValue(option.text, i))(prompt('Enter User name', option.text))
                } :  option;
        }));
    };

    const buttonStyle = {
        position: 'relative',
        right: 0,
        top: 0,
        backgroundColor: 'yellow',
        borderRadius: '1.8rem',
        height: '1.8rem',
        width: '1.8rem',
        cursor: 'pointer',
        fontSize: '1.0rem'
    };

    const getListItem = (k, v, idx, optionIdx) => {

        return (
            <span
                key={`${k}_${idx}`}
                style={{
                    marginRight: '10px',
                    border: '1px solid black',
                    borderRadius: '3px',
                    padding: '3px'
                }}
            >
                { k }
                <span
                    style={{
                        cursor: 'pointer'
                    }}
                >
                    {
                        v ?
                            <span
                                style={{
                                    display: 'inline-block',
                                    marginLeft: '1rem'
                                }}
                                data-key_name={k}
                                data-user_index={optionIdx}
                                onClick={handleEditClick}
                            >
                                { v }
                            </span> :
                            <span
                                style={{
                                    display: 'inline-block',
                                    marginLeft: '1rem',
                                    width: '10px',
                                    height: '10px',
                                    border: '1px solid black'
                                }}
                                data-key_name={k}
                                data-user_index={optionIdx}
                                onClick={handleEditClick}
                            />
                    }
                </span>
            </span>
        );
    };

    const getOptionsList = dropdownOptions => {
        
        return (
            <div>
                {
                    dropdownOptions.map((o, optionIdx) => {
                        return (
                            <div
                                key={`${o.text}_${optionIdx}`}
                                style={{ position: 'relative', marginBottom: '5px' }}
                            >
                                <span
                                    style={{
                                        display: 'inline-block',
                                        marginRight: '1rem',
                                        ...(optionIdx !== 0 ? { color: 'red' } : {}),
                                        fontWeight: 'bold',
                                        cursor: 'pointer'
                                    }}
                                    data-user_index={optionIdx}
                                    onClick={handleTextChange}
                                >
                                    { o.text }
                                </span>
                                {
                                    typeof o.value === 'object' ?
                                        Object.entries(o.value).map(([ k, v ], idx) => {
                                            return getListItem(k, v, idx, optionIdx);
                                        }) :
                                        <span >
                                            { o.value }
                                        </span>
                                }
                                {
                                    optionIdx !== 0 &&

                                    <button
                                        name={optionIdx}
                                        onClick={handleDeletion}
                                        style={buttonStyle}
                                    >
                                        x
                                    </button>
                                }
                            </div>
                        );
                    })
                }
            </div>
        );
    };
    
    const getOptions = () => {
        
        const optionsSource = (modifier ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_SETTINGS_KEY))[settingName].options : dropdownOptions);
        
        return optionsSource.map((o, idx) => {
            return (
                <option
                    key={`${o.text}_${idx}`}
                    value={typeof o.value === 'object' ? JSON.stringify(o.value) : o.value}
                >
                    { o.text }
                </option>
            );
        });
    };

    return (
        <div 
            style={{ 
                display: 'inline-block', 
                borderRadius: '3px', 
                ...(modifier ? { border: '1px solid black' } : {}) 
            }}
        >
            <div>
                <select
                    defaultValue={value}
                    name={settingName}
                    onChange={(...args) => handleInputChange.apply(null, args)}
                >
                    { getOptions() }
                </select>
                {
                    modifier && <button onClick={handleModClick}> Mod </button>
                }
            </div>
            <div>
                {
                    isToggled && getOptionsList(dropdownOptions)
                }
            </div>
        </div>
    );
};

export default DropdownForSettings;